export const DELETE_ADDRESS_ACTION_TYPE = "user/DELETE_ADDRESS";
export const EDIT_PROFILE_ACTION_TYPE = "user/EDIT_PROFILE";
export const ORDERS_NEEDS_ACTION_ACTION_TYPE = "user/ORDERS_NEEDS_ACTION";

export default {
  DELETE_ADDRESS: DELETE_ADDRESS_ACTION_TYPE,
  // old
  LOGIN_REQUEST: "LOGIN_REQUEST",
  LOGIN_SET_PHONE: "LOGIN_SET_PHONE",
  SET_PROFILE: "SET_PROFILE",
  SET_GROUPS: "SET_GROUPS",
  SET_SELECTED_GROUP: "SET_SELECTED_GROUP",
  LOGIN_VERIFY: "LOGIN_VERIFY",
  SET_TOKEN: "SET_TOKEN",
  USER_ADRESS_REQUEST: "USER_ADRESS_REQUEST",
  ADD_ADRESS_REQUEST: "ADD_ADRESS_REQUEST",
  SET_ADDRESS: "SET_ADDRESS",
  ADD_SINGLE_ADDRESS: "ADD_SINGLE_ADDRESS",
  GET_ORDERS: "GET_ORDERS",
  SET_ORDERS: "SET_ORDERS",
  SET_TRANSACTIONS: "SET_TRANSACTIONS",
  SET_RESET: "SET_RESET",
};
